module.exports = __webpack_public_path__ + "static/media/velour9D.0e12a1a8.jpg";